import { Directive, Injector, Input, OnInit } from '@angular/core';
import { LiteralsWords } from 'src/app/i18n/literals.model';
import { LiteralsService } from 'src/app/shared/services/literals-service';
import { CustomFieldsService } from '../services/custom-fields.service';
import { DatePipe } from '@angular/common';
import { PoDynamicFormField } from '@po-ui/ng-components';

@Directive()
export abstract class BaseCustomFields implements OnInit {
  @Input() schemaId: string;
  @Input() isSmallScreen = false;
  @Input() hasMessageForNoFields = false;
  @Input() fieldsValues;
  fields: PoDynamicFormField[] = [];
  isHideLoading = false;
  literals: LiteralsWords;
  loadingText: string;
  datePipe: DatePipe;
  noCustomFields = [];
  protected literalsService: LiteralsService;
  protected customFieldsService: CustomFieldsService;

  constructor(
    protected injector: Injector
  ) {
    this.customFieldsService = injector.get(CustomFieldsService);
    this.literalsService = injector.get(LiteralsService);
    this.datePipe = injector.get(DatePipe);
    this.literals = this.literalsService.getLiteralModule();
  }

  ngOnInit(): void {
    this.loadingText = `${this.literals.str0028} ${this.literals.str0460}...`;
    this.loadCustomFields();
  }

  loadCustomFields(): void {
    this.customFieldsService.getCustomFieldOnStorage(this.schemaId)
      .then(fieldsStorage => {
        this.fields = fieldsStorage ? JSON.parse(fieldsStorage) : [];
        this.fields = this.filterCustomFields(this.fields);
        if (this.fields.length > 0) {
          this.fields = this.fields.map(field => ({
            ...field,
            gridMdColumns: this.isSmallScreen ? 12 : field.gridMdColumns,
            gridLgColumns: this.isSmallScreen ? 12 : field.gridLgColumns,
            gridXlColumns: this.isSmallScreen ? 12 : field.gridXlColumns
          }));
        }
        this.setPresentationFields();
        this.isHideLoading = true;
      });
  }

  isHideWidget(fields: PoDynamicFormField[]): boolean {
    return this.isHideLoading && Object.entries(fields).length > 0;
  }

  filterCustomFields(fields: PoDynamicFormField[]): PoDynamicFormField[] {
    this.noCustomFields = [
      'c5_filial',
      'c5_num',
      'c5_tipo',
      'c5_tabela',
      'c5_condpag',
      'c5_emissao',
      'c5_cliente',
      'c5_lojacli',
      'c5_transp',
      'c5_tpfrete',
      'c5_frete',
      'c5_seguro',
      'c5_despesa',
      'c5_desc1',
      'c5_desc4',
      'c5_moeda',
      'c5_tplib',
      'c5_coda1u',
      'c5_indpres',
      'c5_mennota',
      'c5_coment',
      'cj_filial',
      'cj_num',
      'cj_numtext',
      'cj_tabela',
      'cj_condpag',
      'cj_cliente',
      'cj_loja',
      'cj_prospe',
      'cj_lojpro',
      'cj_emissao',
      'cj_tpfrete',
      'cj_frete',
      'cj_seguro',
      'cj_despesa',
      'cj_desc1',
      'cj_moeda',
      'cj_tiplib',
      'cj_tipocli',
      'cj_status',
      'cj_propost',
      'cj_coda1u',
      'cj_indpres',
      'ck_filial',
      'ck_num',
      'ck_item',
      'ck_produto',
      'ck_descri',
      'ck_qtdven',
      'ck_prunit',
      'ck_prcven',
      'ck_valor',
      'ck_oper',
      'ck_descont',
      'ck_valdesc',
      'ck_tes'
    ]
    return fields.filter(obj => !this.noCustomFields.includes(obj.property));
  }

  abstract setPresentationFields(): void;

}
